import React from 'react';
import ThisProject from '../ThisProject';
import { ImageMedia } from '../../components/imports';


const Content = () => {

  // const BottleShotRef = useRef(null);
  // const animaticRef = useRef(null);

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

          <div className='relative resp flex flex-col lg:flex-row lg:h-[100svh] gap-x-6'>
            <ImageMedia
              bypass={false}
              key={"money"}
              src={require('./assets/preview_isif.jpg')}
              className=""
            />
          </div>

        </div>
      )}
    </ThisProject>
  )
}

export default Content